import { useNode } from '@craftjs/core';
import { ImageControl } from 'pages/PageEditor/settingsComponents/ImageControl';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useMemo } from 'react';
import { EditorBaseImageSettings } from '../../editorBase';

const EditorImageSettings = () => {
	const {
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [onSrcChange] = useMemo(
		() => ['src'].map((attr) => generateOnChange(setProp, attr)),
		[setProp]
	);

	return (
		<div>
			<ImageControl label={intl.tr('button.upload')} setValue={onSrcChange} />
			<EditorBaseImageSettings />
		</div>
	);
};

export { EditorImageSettings };
